import * as React from 'react';
import clsx from 'clsx';

interface AuthCardFrameProps {
  children: React.ReactNode;
}

/** Outer card container for the auth page. Scrollable on mobile, visible overflow on desktop. */
export const AuthCardFrame: React.FC<AuthCardFrameProps> = ({ children }) => (
  <div
    className={clsx(
      'relative z-10 flex',
      'overflow-y-auto fold:overflow-visible',
      'h-[95dvh] min-h-[600px] w-full p-0',
      'fold:h-[85dvh] fold:min-h-0 fold:w-[95%] md:w-[90%]',
      'fold:p-[15px]',
      'wide:h-[85dvh] wide:w-[82vw] wide:gap-[2%]',
      '4xl:aspect-[1553/949] 4xl:h-[87dvh] 4xl:w-auto 4xl:max-w-[1537px] 4xl:gap-[2%]',
      'bg-transparent shadow-none',
      'fold:rounded-[10px] fold:bg-white fold:shadow-2xl'
    )}
  >
    {children}
  </div>
);
